import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DashboardIcon from "@mui/icons-material/Dashboard";
import CodeIcon from "@mui/icons-material/Code";
import BugReportIcon from "@mui/icons-material/BugReport";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Divider } from "@mui/material";
import athrvLogo from "./img/Athrv-white.png";
import CollapsedLogo from "./img/Athrv-white-one part.png";
import "./styles/sidebar.css";
import aws from "./img/aws-main.png";
import logotext from "./img/logo-text.png";
import { Box, Typography, useTheme } from "@mui/material";

const Sidebar = ({ isSidebarExpanded }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const isActive = (path) => location.pathname === path;

  return (
    <div
      className={`athrv-sidebar`}
      style={{
        width: isSidebarExpanded ? 250 : 80,
        marginTop: "-5px",
        transition: "width 0.3s ease-in-out",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "101vh",
        position: "fixed",
        zIndex: 1350,
        backgroundColor: isDarkMode ? "#202020" : "rgb(12, 20, 50)",
        // opacity: isSidebarExpanded ? 1 : 0.9,
        borderRight: "1px solid rgba(255, 255, 255, 0.3)",
        padding: 0,
      }}
    >
      {/* Sidebar Menu */}
      <List>
        <div
          style={{
            backgroundColor: isDarkMode ? "#202020" : "rgb(12, 20, 50)",
            paddingLeft: "15px",
            height: "50px",
            display: "flex",
            alignItems: "center",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <img
            src={CollapsedLogo}
            alt="Collapsed Logo"
            style={{
              width: "45px",
              transition: "filter 0.3s ease-in-out",
              flexShrink: 0,
            }}
          />
          <div
            style={{
              overflow: "hidden",
              width: isSidebarExpanded ? "150px" : "0px",
              marginLeft: "5px",
              transition: "width 0.4s ease-in-out",
            }}
          >
            <img
              src={logotext}
              alt="Athrv Logo"
              style={{
                width: "110px",
                height: "auto",
                opacity: isSidebarExpanded ? 1 : 0,
                transition: "opacity 0.4s ease-in-out",
              }}
            />
          </div>
        </div>

        <Divider
          flexItem
          sx={{
            borderColor: "rgba(255, 255, 255, 0.3)",
            marginBottom: "0px",
            marginTop: "10px",
          }}
        />
        {/* Dashboard Menu Item */}
        <ListItemButton
          className={`athrv-sidebar-item ${
            isActive("/dashboard") ? "active-sidebar-item" : ""
          }`}
          onClick={() => navigate("/dashboard")}
          style={{
            backgroundColor: isActive("/dashboard") ? "white" : "",
            // paddingRight: isSidebarExpanded ? "16px" : "0px",
            paddingLeft: "10px",
            // marginTop: "13px",
          }}
        >
          <ListItemIcon>
            <DashboardIcon className="sidebar-icons" />
          </ListItemIcon>
          {isSidebarExpanded && <ListItemText primary="Dashboard" />}
          {isSidebarExpanded && <ChevronRightIcon className="arrow-icon" />}
          <div
            className={`hover-line ${isSidebarExpanded ? "expanded" : ""}`}
            style={{
              display: isSidebarExpanded ? "block" : "none",
            }}
          ></div>
        </ListItemButton>

        {/* Projects Menu Item */}
        <ListItemButton
          className={`athrv-sidebar-item ${
            isActive("/projects") ? "active-sidebar-item" : ""
          }`}
          onClick={() => navigate("/projects")}
          style={{
            backgroundColor: isActive("/projects") ? "white" : "",
            // paddingRight: isSidebarExpanded ? "16px" : "0px",
            paddingLeft: "10px",
          }}
        >
          <ListItemIcon>
            <CodeIcon className="sidebar-icons" />
          </ListItemIcon>
          {isSidebarExpanded && <ListItemText primary="Projects" />}
          {isSidebarExpanded && <ChevronRightIcon className="arrow-icon" />}
          <div
            className={`hover-line ${isSidebarExpanded ? "expanded" : ""}`}
            style={{
              display: isSidebarExpanded ? "block" : "none",
            }}
          ></div>
        </ListItemButton>

        {/* Issues Menu Item */}
        <ListItemButton
          className={`athrv-sidebar-item ${
            isActive("/issues") ? "active-sidebar-item" : ""
          }`}
          onClick={() => navigate("/issues")}
          style={{
            backgroundColor: isActive("/issues") ? "white" : "",
            // paddingRight: isSidebarExpanded ? "16px" : "0px",
            paddingLeft: "10px",
          }}
        >
          <ListItemIcon>
            <BugReportIcon className="sidebar-icons" />
          </ListItemIcon>
          {isSidebarExpanded && <ListItemText primary="Issues & Errors" />}
          {isSidebarExpanded && <ChevronRightIcon className="arrow-icon" />}
          <div
            className={`hover-line ${isSidebarExpanded ? "expanded" : ""}`}
            style={{
              display: isSidebarExpanded ? "block" : "none",
            }}
          ></div>
        </ListItemButton>

        {/* Testing Menu Item */}
        <ListItemButton
          className={`athrv-sidebar-item ${
            isActive("/testing") ? "active-sidebar-item" : ""
          }`}
          onClick={() => navigate("/testing")}
          style={{
            backgroundColor: isActive("/testing") ? "white" : "",
            // paddingRight: isSidebarExpanded ? "16px" : "0px",
            paddingLeft: "10px",
          }}
        >
          <ListItemIcon>
            <AssignmentTurnedInIcon className="sidebar-icons" />
          </ListItemIcon>
          {isSidebarExpanded && <ListItemText primary="Testing" />}
          {isSidebarExpanded && <ChevronRightIcon className="arrow-icon" />}
          <div
            className={`hover-line ${isSidebarExpanded ? "expanded" : ""}`}
            style={{
              display: isSidebarExpanded ? "block" : "none",
            }}
          ></div>
        </ListItemButton>

        {/* Reporting Menu Item */}
        <ListItemButton
          className={`athrv-sidebar-item ${
            isActive("/reporting") ? "active-sidebar-item" : ""
          }`}
          onClick={() => navigate("/reporting")}
          style={{
            backgroundColor: isActive("/reporting") ? "white" : "",
            // paddingRight: isSidebarExpanded ? "16px" : "0px",
            paddingLeft: "10px",
          }}
        >
          <ListItemIcon>
            <AssessmentIcon className="sidebar-icons" />
          </ListItemIcon>
          {isSidebarExpanded && <ListItemText primary="Reporting" />}
          {isSidebarExpanded && <ChevronRightIcon className="arrow-icon" />}
          <div
            className={`hover-line ${isSidebarExpanded ? "expanded" : ""}`}
            style={{
              display: isSidebarExpanded ? "block" : "none",
            }}
          ></div>
        </ListItemButton>
      </List>
      {/* Divider and Footer */}
      {isSidebarExpanded && (
        <div
          style={{
            marginBottom: "8px",
            textAlign: "center",
            padding: isSidebarExpanded ? "10px" : "5px",
          }}
        >
          <Typography variant="body1" sx={{ mr: 1 }}>
            Powered By
          </Typography>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "2px",
            }}
          >
            <img src={aws} alt="AWS Logo" style={{ height: "70px" }} />
          </div>

          <div
            className="gradient-line"
            style={{
              height: "3px",
              margin: "10px auto",
              background:
                "linear-gradient(to right, transparent, #f0f0f0, transparent)",
              borderRadius: "2px",
            }}
          ></div>

          <p
            className="footer-text"
            style={{
              fontSize: isSidebarExpanded ? "13px" : "10px",
              color: "#f0f0f0",
              marginTop: "10px",
              whiteSpace: "normal",
              textAlign: "center",
            }}
          >
            Athrv Cloud Platform <br />
            &copy; 2025 All Rights Reserved.
          </p>
        </div>
      )}
    </div>
  );
};

export default Sidebar;
